<template>
  <table class="product-rows">
    <thead>
      <tr>
        <th class="product-row__head-image"></th>

        <th class="product-row__head-article-name">
          <div v-epi-edit="'articleNameHeader'" class="product-row__head-inset">
            <span>
              {{ t('articleNameHeader') }}
            </span>
          </div>
        </th>

        <th class="product-row__head-stock-status">
          <div v-epi-edit="'articleCountHeader'" class="product-row__head-inset">
            {{ t('articleCountHeader') }}
          </div>
        </th>

        <th class="product-row__head-quantity">
          <div v-epi-edit="'sendNowQuantityHeader'" class="product-row__head-inset">
            {{ t('sendNowQuantityHeader') }}
          </div>
        </th>

        <th class="product-row__head-quantity">
          <div v-epi-edit="'sendLaterQuantityHeader'" class="product-row__head-inset">
            {{ t('sendLaterQuantityHeader') }}
          </div>
        </th>

        <th v-if="orderHasMachineOrOwner" class="product-row__head-machine">
          <div v-epi-edit="'rowMachineHeader'" class="product-row__head-inset">
            {{ tStatic("cartRowMachineLabel") }}
          </div>
        </th>

        <th class="product-row__head-comment">
          <div v-epi-edit="'rowCommentHeader'" class="product-row__head-inset">
            {{ t('rowCommentHeader') }}
          </div>
        </th>

        <th class="product-row__head-item-price">
          <div v-epi-edit="'rowItemExcludedVatHeader'" class="product-row__head-inset product-row__head-inset--align-right">
            <span>{{ t('rowItemExcludedVatHeader') }}</span>
          </div>
        </th>

        <th class="product-row__head-item-price">
          <div v-epi-edit="'rowSumExcludedVatHeader'" class="product-row__head-inset product-row__head-inset--align-right">
            <span>{{ t('rowSumExcludedVatHeader') }}</span>
          </div>
        </th>

        <!-- <th class="product-row__head-total-price">
          <div v-epi-edit="'rowSumHeader'" class="product-row__head-inset product-row__head-inset--align-right">
            <span>{{ t('rowSumHeader') }}</span>
          </div>
        </th> -->
      </tr>
    </thead>

    <tbody>
      <tr v-for="(row, key) in rows" :key="`table-row-${key}`">
        <td class="product-row__body-td--image">
          <div class="product-row__body-inset">
            <oie-base-image
              :images="row.imageUrl ? getAssetPath(`${row.imageUrl}?preset=ProductSmall&watermark=OIEWatermarkSmall`) : getAssetPath('/globalassets/missing404/404.png?preset=ProductSmall')"
              :alt-text="row.artName"
              image-width="6rem"
              image-height="6rem"
              class="product-row__image"></oie-base-image>
          </div>
        </td>

        <td class="product-row__body-td--article">
          <div class="product-row__body-inset product-row__body-inset--article">
            <div class="product-row__name">
              {{ row.artName }}

              <div class="product-row__article-number">
                {{ t('articleNumberLabel') }} {{ row.artNr }}
              </div>
            </div>
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('articleCountHeader') }}
          </div>

          <div class="product-row__body-inset">
            {{ row.quantity }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('sendNowQuantityHeader') }}
          </div>

          <div class="product-row__body-inset">
            {{ row.sendNowQuantity }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('sendLaterQuantityHeader') }}
          </div>

          <div class="product-row__body-inset">
            {{ row.sendLaterQuantity }}
          </div>
        </td>

        <td v-if="orderHasMachineOrOwner" class="product-row__td--machine">
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ tStatic("cartRowMachineLabel") }}
          </div>

          <div v-if="row.machineOwnerName || row.machineName" class="product-row__body-inset">
            <p v-if="row.machineOwnerName" class="product-row__td--machine-info">
              <oie-base-icon icon="user-avatar" size="s"></oie-base-icon>{{ row.machineOwnerName }}
            </p>
            <p v-if="row.machineName" class="product-row__td--machine-info">
              <oie-base-icon icon="machine" size="s"></oie-base-icon> {{ row.machineName }}
            </p>
          </div>
        </td>

        <td class="product-row__td--comment">
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('rowCommentHeader') }}
          </div>

          <div class="product-row__body-inset">
            {{ row.comment }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('rowItemExcludedVatHeader') }}
          </div>

          <div class="product-row__body-inset product-row__body-inset--align-right product-row__body-inset--price">
            {{ formatPrice(row.priceForEachItem) }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('rowSumExcludedVatHeader') }}
          </div>

          <div class="product-row__body-inset product-row__body-inset--align-right product-row__body-inset--price">
            {{ formatPrice(row.priceExcludedVat) }}
          </div>
        </td>

        <!-- <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('rowSumHeader') }}
          </div>

          <div class="product-row__body-inset product-row__body-inset--align-right product-row__body-inset--price">
            5433kr
          </div>
        </td> -->
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    rows: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    orderHasMachineOrOwner() {
      return this.rows.some(row => row.machineOwnerName || row.machineName)
    }
  }
}
</script>
